import React from "react";
import * as styles from "./Box.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Icon from "../Icon/Icon";
import { Link } from "react-router-dom";

/** @js-doc
 *
 * @param icon {string}
 * @param count {number}
 * @param {("red"|"orange"|"purple"|"accident")} color
 * @param className=
 * @returns {React.JSX.Element}
 * @constructor
 */
const IconBadge = ({ icon, count, color, className }) => {
	const classes = classNames(className, styles["icon-badge"], {
		[styles[`bg-${color}`]]: !!color,
	});
	return (
		<div className={classes}>
			<Icon icon={icon} size={12} className={styles["icon"]} />
			<span className={styles["badge-count"]}>{count}</span>
		</div>
	);
};

const Box = ({ headline, count = 0, link, className, info = {} }) => {
	const boxClassName = classNames({
		[styles["box"]]: true,
		[styles["box--with-info"]]: count !== 0,
		[className]: !!className,
	});

	return (
		<Link to={link} className={boxClassName}>
			<div className={styles["content-box"]}>
				<span className={styles["title"]} dangerouslySetInnerHTML={{ __html: headline }} />
				{(info?.accident > 0 || info?.dueUrgent > 0 || info?.dueSoon) > 0 && (
					<div className={styles["counters-box"]}>
						{info?.accident > 0 && (
							<IconBadge icon={"warning-lines-regular"} count={info?.accident} color={"accident"} />
						)}
						{info?.dueUrgent > 0 && (
							<IconBadge icon={"stopwatch-quater"} count={info?.dueUrgent} color={"red"} />
						)}
						{info?.dueSoon > 0 && (
							<IconBadge icon={"stopwatch-half"} count={info?.dueSoon} color={"orange"} />
						)}
					</div>
				)}
			</div>
			<div className={styles["arrow-box"]}>
				{count !== 0 && <span className={styles["count"]}>{count}</span>}
				<Icon icon={"arrow-right"} size={20} className={styles["arrow"]} />
			</div>
		</Link>
	);
};

Box.propTypes = {
	headline: PropTypes.string.isRequired,
	count: PropTypes.number,
	link: PropTypes.string,
	className: PropTypes.string,
	info: PropTypes.shape({
		accident: PropTypes.number,
		dueUrgent: PropTypes.number,
		dueSoon: PropTypes.number,
	}),
};

export default Box;
